<div class="diamond-balance">
  <i class="fas fa-gem"></i>
  <span>{{ value }}</span>
</div>
